$(document).ready(function(){
var swiper = new Swiper('.custom_video_slider-11', {
  scrollbar: {
    el: '.slider-scrollbar',
    hide: false,
    draggable: true,
    // dragSize: 100,
  },
  slidesPerView: 1,
  spaceBetween: 20,
  
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 480px
    625: {
      slidesPerView: 2,
    },
    // when window width is >= 640px
    1024: {
      slidesPerView: 4,
    }
  }
});
});


// $('.custom_video_slider-11').slick({
//     dots:false,
//     infinite: false,
//     speed: 300,
//      prevArrow: false,
//     nextArrow: false,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll:1,
//           infinite: true,
//           dots:false
//         }
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ]
//   });

// ==============review slider============

$(document).ready(function(){
  $('.review-slider-div').slick({
     speed:300,
     slidesToShow:3,
     slidesToScroll:3,
     arrows:true,
     prevArrow:'<button type="button" data-role="none" class="slick-prev review_buttons"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13.5 8h-11M7 3.5 2.5 8 7 12.5" stroke="#202020" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
     nextArrow:'<button type="button" data-role="none" class="slick-next review_buttons"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2.5 8h11M9 3.5 13.5 8 9 12.5" stroke="#202020" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
     infinite:true,
     responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll:2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px',
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]

  });
});


$(document).ready(function(){
  $('.collections-slider-div').slick({
     speed:300,
     slidesToShow:3,
     slidesToScroll:3,
     prevArrow: false,
    nextArrow: false,
     infinite:true,
     responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll:2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]

  });
});


$(document).ready(function(){
  $('.collection_slider_bottom').slick({
    slidesToShow: 4,
    infinite:true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed:0,
    speed:10000,
    rtl:false,
    pauseOnHover:true,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots:false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
})


   // document.addEventListener("DOMContentLoaded", function () {
   //    var addToCartContainer = document.querySelector(".sticky-ctas");

   //    window.addEventListener("scroll", function () {
   //       // Adjust the value (100 in this example) based on when you want the button to appear
   //       if (window.scrollY > 835 ) {
   //          addToCartContainer.classList.add("sticky-show");
   //       } else {
   //          addToCartContainer.classList.remove("sticky-show");
   //       }
   //    });
   // });


if (window.matchMedia("(min-width:768px)").matches) {
  document.addEventListener("DOMContentLoaded", function () {
    var addToCartContainer = document.querySelector(".sticky-ctas");
    if( addToCartContainer ){
      var section = document.querySelector(".cus_redirect_button");
      var productmethod = document.querySelector(".product-single__title").offsetHeight;
      var looxrating = document.querySelector(".loox-rating").offsetHeight;
      var variantwrapper = document.querySelector(".variant-wrapper").offsetHeight;
      var custom_compa = document.querySelector(".custom_compa").offsetHeight;
      var product_single__form = document.querySelector(".product-single__form").offsetHeight;
      var total = productmethod + looxrating + variantwrapper + custom_compa + product_single__form;
      
      console.log(total);
      
      window.addEventListener("scroll", function () {
        var triggerHeight = section.offsetTop + section.offsetHeight + total;
        var scrollPosition = window.scrollY;
    
        if (scrollPosition > 700) {
          addToCartContainer.classList.add("sticky-show");
        } else {
          addToCartContainer.classList.remove("sticky-show");
        }
      });
    }
  });
}

if (window.matchMedia("(max-width:767px)").matches) {
   document.addEventListener("DOMContentLoaded", function () {
      var addToCartContainer = document.querySelector(".sticky-ctas");
      if (!addToCartContainer) return;

      window.addEventListener("scroll", function () {
         // Adjust the value (100 in this example) based on when you want the button to appear
         if (window.scrollY > 900 ) {
            addToCartContainer.classList.add("sticky-show");
         } else {
            addToCartContainer.classList.remove("sticky-show");
         }
      });
   });
}


// Selecting all elements with the class '.variant__button-label'
var variantButtons = document.querySelectorAll('.variant__button-label');

// Iterating over each selected element
variantButtons.forEach(function(button) {
    // Adding a click event listener to each button
    button.addEventListener('click', function() {

        // start bundling price updated code
        //   var variantSaleprice = this.getAttribute('data-price');
        //   var variantComparePrice = this.getAttribute('data-comp-price');
        //   var variantSaleprice = this.getAttribute('data-price');
        //   var variantComparePrice = this.getAttribute('data-comp-price');
        //   function formatCurrency(value) {
        //       return new Intl.NumberFormat('en-IN', {
        //           style: 'currency',
        //           currency: 'USD',
        //           minimumFractionDigits: 2
        //       }).format(value / 100); 
        //   }
        //   var formattedSalePrice = formatCurrency(variantSaleprice);
        //   var formattedComparePrice = formatCurrency(variantComparePrice);
        //  var salePriceElement = document.querySelector('.product-price-box .product-regular-price');
        //   var comparePriceElement = document.querySelector('.product-price-box .product-compare-price');
        //   if (salePriceElement) {
        //     salePriceElement.textContent = formattedSalePrice;
        //   }
        //   if (comparePriceElement) {
        //     comparePriceElement.textContent = formattedComparePrice;
        //   }

        // Start bundling price update code
var variantSaleprice = this.getAttribute('data-price');
var variantComparePrice = this.getAttribute('data-comp-price');
variantSaleprice = parseFloat(variantSaleprice);
variantComparePrice = parseFloat(variantComparePrice);
function formatCurrency(value) {
    var currencyCode = document.body.getAttribute('data-currency') || 'USD'; 
    return new Intl.NumberFormat(undefined, { 
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2
    }).format(value / 100); 
}
var formattedSalePrice = formatCurrency(variantSaleprice);
var formattedComparePrice = formatCurrency(variantComparePrice);
var salePriceElement = document.querySelector('.product-price-box .product-regular-price');
var comparePriceElement = document.querySelector('.product-price-box .product-compare-price');
if (salePriceElement) {
    salePriceElement.textContent = formattedSalePrice;
}
if (comparePriceElement) {
    if (variantComparePrice > 0) {
        comparePriceElement.textContent = formattedComparePrice;
        comparePriceElement.style.display = 'inline'; 
    } else {
        comparePriceElement.textContent = '';
        comparePriceElement.style.display = 'none'; 
    }
}

        // end bundling price updated code 
      
        // Getting the value of the 'data-val' attribute of the clicked button
        var variantValue = this.getAttribute('data-val');
        // Logging the variant value to the console for debugging
        console.log("Variant Value:", variantValue);
      // start price percentage 
        // var variantPrice = this.getAttribute('data-price');
        // var variantComparePrice = this.getAttribute('data-compare-price');
        // if (variantComparePrice > variantPrice) {
        //   var priceDifference = variantComparePrice - variantPrice;
        //   var discountPercentage = (priceDifference * 100) / variantComparePrice;
        //   var roundedDiscount = discountPercentage.toFixed(2);
        //   setTimeout(function () {
        //     var addToCartBtn = document.querySelector('[data-add-to-cart-text]');
        //     if (addToCartBtn) {
        //       var oldPercentage = addToCartBtn.querySelector('.price-percentage');
        //       if (oldPercentage) {
        //         oldPercentage.remove();
        //       }
        //       var discountSpan = document.createElement('span');
        //       discountSpan.className = 'price-percentage';
        //       discountSpan.textContent = ' - ' + roundedDiscount + '% OFF';
        
        //       addToCartBtn.appendChild(discountSpan);
        //     }
        //   }, 100); 
        // }
        // end price percentage 
        // Selecting the element with the class '.color_id' and setting its text content to the variant value
        // document.querySelector('.variant-pick-7 .color_id').textContent = variantValue;
        // document.querySelector('.variant-pick-3 .color_id').textContent = variantValue;
        var elements = [
          document.querySelector('.variant-pick-6 .color_id'),
          document.querySelector('.variant-pick-7 .color_id'),
          document.querySelector('.variant-pick-3 .color_id')
        ];
        elements.forEach(function(element) {
          if (element) {
            element.textContent = variantValue;
          }
        });
    });
});


if( document.querySelector('.product-single__title') != null ){
const productTitle = document.querySelector('.product-single__title');

// Get the text content of the element
const text = productTitle.textContent;

// Split the text content by spaces
const words = text.split(' ');

// Empty the content of the element
productTitle.innerHTML = '';

// Loop through each word
words.forEach((word, index) => {
    // Create a span element
    const span = document.createElement('span');
    
    // Set the text content of the span to the word
    span.textContent = word;
    
    // If the word has a leading and trailing space, and it's not the first or last word
    if (index > 0 && index < words.length - 1 && words[index - 1] === '' && words[index + 1] === '') {
        // Add a CSS class to make it red
        span.classList.add('red-word');
    }
    
    // Append the span element to the productTitle element
    productTitle.appendChild(span);
});
}



if( document.querySelector('#money-back-btn') != null ){
document.querySelector("#money-back-btn").addEventListener("click", function(e) {
  e.preventDefault();
  var firstCustomTab = document.querySelector('.collapsible-trigger');
  if (firstCustomTab) {
    firstCustomTab.click();
  }
});
}










